import { X } from 'lucide-react';
import Modal from './Modal';

interface DeleteConfirmationDialogProps {
  setShowDeleteConfirm: (item: any) => void;
  onConfirm: () => void;
  text: string;
  confirmText?: string;
}

const DeleteConfirmationDialog: React.FC<DeleteConfirmationDialogProps> = ({
  setShowDeleteConfirm,
  onConfirm,
  text,
  confirmText,
}) => {
  return (
    <Modal isOpen={true} onClose={() => setShowDeleteConfirm(null)}>
      <div className="p-6">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold">ยืนยันการลบ</h2>
          <button
            onClick={() => setShowDeleteConfirm(null)}
            className="text-gray-400 hover:text-gray-600 focus:outline-none"
          >
            <X size={24} />
          </button>
        </div>

        <p className="text-gray-600 mb-6">{text}</p>

        <div className="flex justify-end space-x-1">
          <button
            onClick={() => setShowDeleteConfirm(null)}
            className="px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
          >
            ยกเลิก
          </button>
          <button
            onClick={() => onConfirm()}
            className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
          >
            { confirmText ?? 'ลบชิ้นส่วน' }
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteConfirmationDialog;
